<template>

	<div :class="{query:true,'show-bottom':showAtBottom, minimal: minimal, 'has-clear-button':showClear}" v-if="(searchQuery && searchQuery.length>0) || (orderBySelected && orderBySelected.length>0) || !!descriptionOverride" @click="clicked">
  
	  <h4 class="query-title" v-html="titleCompd" />
  
	  <span class="large-button mini flip-colours hover-white clear-button" v-if="showClear" @click="clearAll">Clear</span>
  
	  <div class="query-scroll" v-if="descriptionOverride">
  
		<div class="query-line">
  
		  <span class="query-line-inner" v-html="descriptionOverride" />
  
		</div>
  
	  </div>
  
	  <div class="query-scroll" v-if="!descriptionOverride">
  
		<div
		  v-for="(filters, filtersIndex) in searchQuery" 
		  :key="'filters-'+filtersIndex"
		  class="query-line"
		>
  
		  <span class="or" v-if="filtersIndex>0"> OR </span>
  
		  <span class="query-line-inner">
  
			<span
			  v-for="(filter, filterIndex) in filters" 
			  :key="'filter-2-'+filterIndex"
			>
  
			  <span class="and" v-if="filterIndex>0"> AND </span>
  
			  <span v-html="filter.label" :class="{empty:filter.empty}" />
  
			  <span
				v-for="(option, optionIndex) in filter.options" 
				:key="'filter-option-'+optionIndex"
			  >
  
				<span v-if="optionIndex>0"> and </span>
  
				<span class="comparison" v-html="option.comparison" /> 
				
				<span
				  v-for="(value, valueIndex) in option.values" 
				  :key="'value-'+valueIndex"
				>
  
				  <span v-if="valueIndex>0&&value!==''"> or </span>
  
				  <span class="value" v-if="value!==''">"{{value}}"</span>
  
				</span>
				
			  </span>
  
			</span>
  
		  </span>
  
		</div>
  
		<div v-if="hasOrderBy&&orderBySelectedCompd.length>0">
  
		  <h4 class="query-title order-by">Ordered By</h4>
  
		  <span
			v-for="(orderBy, orderByIndex) in orderBySelectedCompd" 
			:key="'order-by-'+orderByIndex"
		  >
  
			<span v-if="orderByIndex>0" class="comparison">,<br />then </span>
  
			<span v-if="searchSetup[orderBy.field]">{{searchSetup[orderBy.field].showLabel}}</span> <span class="direction" v-html="orderBy.direction==='asc'?'Ascending':'Descending'" />
  
		  </span>
  
		</div>
  
	  </div>
  
	</div>
  
  </template>
  
  <script>
  import { computed } from 'vue';
  
  export default {
	name: 'TableFilterQuery',
	props: {
	  searchQuery: {
		type: Array,
		default: function () { return []; }
	  },
	  orderBySelected: {
		type: Array,
		default: function () { return []; }
	  },
	  searchSetup: {
		type: Object,
		default: () => { return {}; }
	  },
	  hasOrderBy: {
		type: Boolean,
		default: false
	  },
	  showAtBottom: {
		type: Boolean,
		default: false
	  },
	  minimal: {
		type: Boolean,
		default: false
	  },
	  showClear: {
		type: Boolean,
		default: false
	  },
	  title: {
		type: String,
		default: ''
	  },
	  descriptionOverride: {
		type: String,
		default: ''
	  }
	},
	setup(props, { emit }) {
	  const titleCompd = computed(() => {
		return props.title || 'Your Query';
	  });
  
	  const orderBySelectedCompd = computed(() => {
		let list = [];
		if (props.orderBySelected) {
		  props.orderBySelected.forEach((orderBy) => {
			if (orderBy && orderBy.field && orderBy.direction) {
			  list.push(orderBy);
			}
		  });
		}
		return list;
	  });
  
	  const clicked = () => {
		emit('clicked');
	  };
  
	  const clearAll = (e) => {
		e.stopPropagation();
		emit('clearAll');
	  };
  
	  return {
		titleCompd,
		orderBySelectedCompd,
		clicked,
		clearAll
	  };
	}
  }
  </script>
  <style lang="less" scoped>
  @import './../assets/css/less/_helper.less';
  @import './../assets/css/less/_settings.less';
  .query {
  
	background-color: @darkContrast;
	color: #fff;
	.rounded(5px);
	padding: 10px;
	font-size: 14px;
	margin: 20px 0 0;
	position: relative;
  
	.clear-button {
  
	  position: absolute;
	  right: 15px;
	  top: 50%;
	  margin-top: -13px;
  
	}
  
	&.has-clear-button {
  
	  padding-right: 100px;
  
	}
  
	div, span, .query-title {
  
	  color: #fff;
  
	}
  
	.query-title {
  
	  margin-bottom: 5px;
	  font-size: 16px;
  
	  &.order-by {
  
		margin-top: 10px;
  
	  }
  
	}
  
	span {
  
	  color: #fff;
  
	  &.comparison, &.empty {
  
		.opacity(0.8);
  
	  }
  
	  &.or {
  
		display: block;
		padding: 5px 10px;
		font-weight: @bold;
  
	  }
  
	  &.and {
  
		display: inline-block;
		padding: 0 7px 0 10px;
  
	  }
  
	  &.value {
  
		font-weight: @bold;
  
	  }
  
	  &.direction {
  
		font-style: italic;
  
	  }
  
	}
  
	&.minimal {
  
	  .query-title {
  
		margin-bottom: 0;
  
	  }
  
	  .query-line, .query-scroll {
  
		display: inline-block;
  
	  }
  
	  span {
  
		&.or {
  
		  display: inline-block;
  
		}
  
	  }
  
	}
  
  }
  
  @media screen and (min-width: 1024px) and (min-height: 600px) {
	.query.show-bottom {
  
	  position: fixed;
	  left: 0;
	  bottom: 0;
	  border-radius: 0;
	  width: 100%;
	  padding: 10px 185px 10px 10px;
	  margin: 0;
	  z-index: 2;
  
	  .query-scroll {
  
		max-height: 80px;
		overflow-y: auto;
  
  
	  }
  
	  span {
  
		&.and {
  
		  padding: 0 5px 0 7px;
		  font-weight: @bold;
  
		}
  
	  }
  
	  .query-title {
  
		margin-bottom: 0;
  
	  }
  
	  .query-line {
  
		margin-top: 5px;
  
		span {
  
		  color: inherit;
  
		}
  
		.query-line-inner {
  
		  padding: 1px 3px;
			
  
		}
  
	  }
  
	  .query-line, span.or {
  
		display: inline-block;
		margin-right: 10px;
		padding: 0;
  
		&:last-child {
  
		  margin-right: 0;
  
		}
  
	  }
  
	  span.or {
  
		margin-right: 8px;
		background-color: #fff;
		color: @darkContrast;
		border-radius: 2px;
		padding: 1px 3px 1px 2px;
  
	  }
  
	}
  }
  </style>